import { createListenerMiddleware } from '@reduxjs/toolkit';

import { routes } from '~constants/routes';
import { sendEvent } from '~features/annals';
import eventsCommonNames from '~features/annals/events/common';
import { deleteDefaultPromocode } from '~features/promocode';
import { ssKeys } from '~features/storage';
import { WebPushService } from '~services/webpush';
import { TokenManager } from '~shared/services/ClientTokenManager';
import { getNSFWOrigin, getSFWOrigin, isSafeApp } from '~shared/utils/host';
import { removeToken } from '~utils/token';

import type { RootState } from '../index';
import { logout } from '../utils/logout';

const iframeOrigin = isSafeApp ? getNSFWOrigin() : getSFWOrigin();

export const userData = createListenerMiddleware();
// logout, clear user data
userData.startListening({
	actionCreator: logout,
	effect: async (_, listenerApi) => {
		const redirectedTo = routes.explore.home;
		const redirectedFrom = window.location.toString();
		const userId = (listenerApi.getState() as RootState).auth.info.id;
		await sendEvent({
			userId,
			event: eventsCommonNames.userRedirected,
			body: {
				redirected_from: redirectedFrom,
				redirect_to: redirectedTo,
				timestamp: (Date.now() / 1000) | 0,
			},
		});
		void WebPushService(listenerApi).unsubscribeWebPush();
		deleteDefaultPromocode();
		TokenManager.clearToken('main');
		// TODO: Remove usqge in next releases
		await removeToken();
		window.localStorage.clear();
		window.sessionStorage.setItem(ssKeys.LOGGED_OUT_MANUAL, 'true');

		// use iframe to logout from other domain
		const iframe = document.createElement('iframe');
		iframe.src = `${iframeOrigin}/auth/sync-logout`;
		iframe.style.display = 'none';
		document.body.appendChild(iframe);

		const fallbackTimeout = setTimeout(() => {
			iframe.remove();
			window.location.replace(redirectedTo);
		}, 5000);

		window.addEventListener(
			'message',
			function handleLogoutSync(event: { data: { type: string } }) {
				if (event.data?.type === 'logout-complete') {
					clearTimeout(fallbackTimeout);
					iframe.remove();
					window.location.replace(redirectedTo);
					window.removeEventListener('message', handleLogoutSync);
				}
			}
		);
	},
});
